import { COLORS, FILES_PATH, IMAGES } from ".";
const {
  E_SDG_logo01,
  E_SDG_logo02,
  E_SDG_logo03,
  E_SDG_logo04,
  E_SDG_logo05,
  E_SDG_logo06,
  E_SDG_logo07,
  E_SDG_logo08,
  E_SDG_logo09,
  E_SDG_logo10,
  E_SDG_logo11,
  E_SDG_logo12,
  E_SDG_logo13,
  E_SDG_logo14,
  E_SDG_logo15,
  E_SDG_logo16,
  E_SDG_logo17,
} = IMAGES;
const dataSdgImages=[
  E_SDG_logo01,
  E_SDG_logo02,
  E_SDG_logo03,
  E_SDG_logo04,
  E_SDG_logo05,
  E_SDG_logo06,
  E_SDG_logo07,
  E_SDG_logo08,
  E_SDG_logo09,
  E_SDG_logo10,
  E_SDG_logo11,
  E_SDG_logo12,
  E_SDG_logo13,
  E_SDG_logo14,
  E_SDG_logo15,
  E_SDG_logo16,
  E_SDG_logo17,
];
  export default dataSdgImages;